import { Stack } from '@mui/material'
import { TableCellProps } from '@mui/material/TableCell/TableCell'
import { roundingNumber } from 'components/shared/processes'
import { Herd } from 'models/IFarm'
import { CustomTableRowProps } from 'ui/table/CustomTableRow'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'

interface useGetCellOptionsProps {
	herd: Herd
}

export const useGetCellOptions = ({
	herd,
}: useGetCellOptionsProps): CustomTableRowProps[] => {
	const SEGMENTS = [
		{ label: 'Дойные', color: '#5222D0', value: herd?.milky ?? 0 },
		{
			label: 'Сухостой',
			color: 'rgba(82, 34, 208, 0.4)',
			value: herd?.dry ?? 0,
		},
	]

	const SUM_HERD_COUNT = SEGMENTS.reduce((sum, el) => sum + (el.value || 0), 0)

	const TABLE_OPTIONS: CustomTableRowProps[] = SEGMENTS.map(el => ({
		rowKey: 'tableStructureHerdWidgetRow',
		rowHeight: '18px',
		cellItems: [
			{
				padding: '4px 0px 0px 0px',
				children: (
					<Stack direction='row' alignItems='center' gap='4px'>
						<span
							style={{
								width: '8px',
								height: '8px',
								backgroundColor: el.color,
								borderRadius: '50%',
							}}
						/>
						<TypographyPrimary>{el.label}</TypographyPrimary>
					</Stack>
				),
				align: 'left' as TableCellProps['align'],
			},
			{
				padding: '4px 0px 0px 0px',
				children: el.value ?? '-',
				align: 'left' as TableCellProps['align'],
			},
			{
				padding: '4px 0px 0px 0px',
				children: SUM_HERD_COUNT
					? roundingNumber(((el.value || 0) / SUM_HERD_COUNT) * 100, 0)
					: '-',
				align: 'right' as TableCellProps['align'],
			},
		],
	}))

	return TABLE_OPTIONS
}
